module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slot"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showProgramLoader) ? _c('div', {
    staticClass: "loader__spinner-container epg__loader epg__loader--program"
  }, [_c('div', {
    staticClass: "loader__spinner"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade--area"
    }
  }, [(!_vm.showProgramLoader) ? _c('div', {
    staticClass: "epg__slot-inner"
  }, [_c('h3', {
    staticClass: "epg__slot-title"
  }, [_vm._v(_vm._s(_vm.selectedProgram.title))]), _vm._v(" "), _c('div', {
    staticClass: "epg__slot-subheader"
  }, [_c('span', {
    staticClass: "epg__slot-suitability-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedProgram.suitabilityImageSrc
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "epg__slot-separator"
  }, [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    staticClass: "epg__slot-duration"
  }, [_vm._v(_vm._s(_vm.selectedProgram.duration) + " '")]), _vm._v(" "), _c('span', {
    staticClass: "epg__slot-separator"
  }, [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    staticClass: "epg__slot-category"
  }, [_vm._v(_vm._s(_vm.selectedProgram.category))])]), _vm._v(" "), _c('p', {
    class: [
      'epg__slot-description',
      {
        'epg__slot-description--max': _vm.contentMode === 'max',
        'epg__slot-description--min': _vm.contentMode === 'min'
      }
    ]
  }, [_c('span'), _vm._v(" "), (_vm.contentMode === 'min') ? _c('span', {
    staticClass: "epg__slot-text epg__slot-text--min"
  }, [_vm._v(_vm._s(_vm.miniText))]) : _vm._e(), _vm._v(" "), (_vm.contentMode === 'max') ? _c('span', {
    class: ['epg__slot-text', 'epg__slot-text--max', {
      'epg__slot-text--show': _vm.isMaxTextShown
    }]
  }, [_vm._v("\n                    " + _vm._s(_vm.maxText) + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.miniText.length !== _vm.maxText.length) ? _c('a', {
    staticClass: "epg__link epg__link--more",
    on: {
      "click": function($event) {
        _vm.toggleContentMode()
      }
    }
  }, [(_vm.contentMode === 'min') ? _c('span', [_vm._v(_vm._s(_vm.moreLabel))]) : _vm._e(), _vm._v(" "), (_vm.contentMode === 'max') ? _c('span', [_vm._v(_vm._s(_vm.lessLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "epg__btn epg__btn--close",
    on: {
      "click": function($event) {
        _vm.closeSlot()
      }
    }
  }, [_c('svg', {
    staticClass: "epg__icon epg__icon--close"
  }, [_c('use', {
    attrs: {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": "#icon-close"
    }
  })])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0315c9b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectedSlot/SelectedSlot.vue
// module id = 231
// module chunks = 1